import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject } from 'rxjs';
import { Api } from 'src/app/shared/constants/api';
import { DataService } from 'src/app/shared/services/data.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';
import { ICharge, IChargeCriteria } from '../../charge/charge.interface';
import { IGst } from '../../gst/gst.interface';
import { GstUpdateFormComponent } from '../gst-update-form/gst-update-form.component';

@Component({
    selector: 'app-map-segment-charge-detail',
    templateUrl: './map-segment-charge-detail.component.html',
    styleUrls: ['./map-segment-charge-detail.component.less'],
    standalone: false
})
export class MapSegmentChargeDetailComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,private utilityService:UtilityService,
              private router:Router, private activatedRoute:ActivatedRoute,
              private service:DataService,private logger:NGXLogger,private dailog:MatDialog) {
                this.initializeForm();
              }

  chargeDetailColumns=['chargeCode','chargeName','taxable','chargeTypeMechanism','sacCode','sacName','sgst','cgst','igst','gstWef','deactivated','updateGst','action'];
  chargeDetailsDataSource=new BehaviorSubject<AbstractControl[]>([]);
  chargeDetailForm:FormGroup;
  chargeTypeMechanismList:any;
  chargeCriteria:IChargeCriteria={}
  filteredCharges=new BehaviorSubject<ICharge[]>([]);
  filteredSAC=new BehaviorSubject<IGst[]>([]);
  charges:any;
  gstList:any;
  mandatory:boolean=false;
  taxableList=this.utilityService.getYesNoList();
  @Input() set isMandatory(value:boolean){
    this.mandatory=value;
    if(this.mandatory && !this.chargeDetails.length){
      this.chargeDetails.push(this.chargeForm());
      this.chargeDetailsDataSource.next(this.chargeDetails.controls);
    }
  }

  @Input() set patchValue(res:any){ 
    if(res=='clear'){
      this.chargeDetails.clear();
      this.chargeDetailsDataSource.next(this.chargeDetails.controls);
    } else if(res){
      this.chargeDetails.clear();
      res.forEach((element,index) => {
        element.show=element.activeDetail?true:false;
        this.chargeDetails.push(this.chargeForm(element));
        this.patchChargeNameToSezDetails(element,index);
        this.patchSacNameToSezDetails(element,index);
        this.chargeDetailsDataSource.next(this.chargeDetails.controls);
      });
    }
  }

  @Input() set disableForm(res:any){ 
    if(res){
      this.chargeDetailForm.disable();
    }
  }


  ngOnInit(): void {
    this.getChargeTypeMechanism();
    this.getCharges();
    this.getGstList();
  }

  private initializeForm(): void {
    this.chargeDetailForm=this.formBuilder.group({
      chargeDetails:this.formBuilder.array([])
    });
    this.chargeDetailsDataSource.next(this.chargeDetails.controls);
  }

  private chargeForm(data?:any) {
    let form= this.formBuilder.group({
      id:[data?data.id:null],
      chargeId:[data?data.chargeId:null,[Validators.required]],
      chargeName:[data?data.chargeName:null],
      taxable:[data?data.taxable:null, [Validators.required]],
      chargeTypeMechanism:[data?data.chargeTypeMechanism:null, [Validators.required]],
      sgst:[data?data.sgst:null, [Validators.required,Validators.pattern('^[0-9.]+$')]],
      cgst:[data?data.cgst:null, [Validators.required,Validators.pattern('^[0-9.]+$')]],
      igst:[data?data.igst:null, [Validators.required,Validators.pattern('^[0-9.]+$')]],
      deactivated:[data?data.deactivated:false],
      chargeList:[this.charges],
      chargeSearch:[],
      sacId:[data?data.sacId:null,[Validators.required]],
      sacName:[data?data.sacName:null],
      sacList:[this.gstList],
      sacSearch:[],
      gstWef:[data?data.gstWef:null,[Validators.required]],
      gstWet:[data?data.gstWet:null],
      activeDetail:[data?data.activeDetail:true],
      show:[data?data.show:true],
    });
    this.searchValueChangeInFormArray(form,this.filteredCharges,'chargeSearch','chargeList');
    this.searchValueChangeInFormArray(form,this.filteredSAC,'sacSearch','sacList');
    return form;
  }

  public searchValueChangeInFormArray(form:any,observableName:any,searchControlName:any,selectListControlName:any){
    form.get(searchControlName).valueChanges.subscribe((searchText) => {
      observableName.subscribe((items) => {
        if (searchText) {
          form.get(selectListControlName).setValue(
            items.filter((item) => item?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
                                      item?.code?.toLowerCase().includes(searchText.toLowerCase())),
          );
        } else {
          form.get(selectListControlName).setValue(items);
        }
      });
    });
  }

  deactivateChanged(item:any,event:any){
    if(event.checked){
      item.get('gstWet').reset();
      let index=_.findIndex(this.chargeDetails.value,{id:null});
      if(index>-1){
        this.chargeDetails.removeAt(index);
      }
      this.chargeDetailsDataSource.next(this.chargeDetails.controls);
    } 
  }

  removeChargeField(index:number){
    this.chargeDetails.removeAt(index);
    this.chargeDetailsDataSource.next(this.chargeDetails.controls);
  }

  addChargeField(item?:any){
    if(!item){
      this.chargeDetails.push(this.chargeForm());
      this.chargeDetailsDataSource.next(this.chargeDetails.controls);
      return;  
    }
    if(item.invalid){
      item.markAllAsTouched();
      return;
    }
    this.chargeDetails.push(this.chargeForm());
    this.chargeDetailsDataSource.next(this.chargeDetails.controls);
  }

  checkChargeDisableCondition(c:any){
    return (_.findWhere(this.chargeDetails.value,{chargeId:c.parentId})) || (c.status!='APPROVED')?true:false;
  }

  chargedChanged(item:any,i:number){
    let chargeById=_.findWhere(this.charges,{id:item.get('chargeId').value});
    item.get('chargeName').setValue(chargeById?.name);
  }

  sacChanged(item:any,i:number){
    let sacById=_.findWhere(this.gstList,{id:item.get('sacId').value});
    item.get('sacName').setValue(sacById?.name);
  }

  dateChangeEvent(event:any,item:any){
    let formattedDate=moment(event.value).utc(true).toDate();
    item.get('gstWef').setValue(formattedDate);
  }

  openGstEditForm(chargeId?:number){
    let data=_.where(this.chargeDetails.value,{chargeId:chargeId});
    const dailogRef=this.dailog.open(GstUpdateFormComponent,{
      data:data,
      maxWidth:"950px",
      maxHeight:"500px"
    });

    dailogRef.afterClosed().subscribe(dailogResult => {
      if(dailogResult==false){
        return;
      } else {
        if(this.chargeDetails.length > 0){
          dailogResult.forEach(element => {
            if(element.id){
              let index = _.findIndex(this.chargeDetails.value, {id:element.id});
              this.chargeDetails.at(index).get('gstWet').setValue(element.gstWet);
              this.chargeDetails.at(index).get('activeDetail').setValue(false);
            } else {
              this.chargeDetails.push(this.chargeForm(element));
            }
          })
        }
        this.chargeDetailsDataSource.next(this.chargeDetails.controls);
      }
    })
  }

  getCharges(){
    this.chargeCriteria['active.equals']=true;
    this.service.get(Api.CHARGE_FOR_DD,this.chargeCriteria).subscribe(res => {
      if(res){
        this.charges=res;
        this.filteredCharges.next(this.charges);
        this.patchChargeListToForm();
      }
    })
  }

  private patchChargeListToForm(){
    this.chargeDetails.value.forEach((element,index) => {
      this.chargeDetails.at(index).get('chargeList').setValue(this.charges);
      this.patchChargeNameToSezDetails(element,index);
    });
    this.chargeDetailsDataSource.next(this.chargeDetails.controls);
  }

  private patchChargeNameToSezDetails(element,index){
    let chargeById=_.findWhere(this.charges,{parentId:element.chargeId});
    this.chargeDetails.at(index).get('chargeName').setValue(chargeById?.name);
 }

  getGstList(){
    this.service.get(Api.GST_FOR_DD).subscribe(res => {
      if(res){
        this.gstList=res;
        this.filteredSAC.next(this.gstList);
        this.patchSacListToForm();
      }
    })
  }

  private patchSacListToForm(){
    this.chargeDetails.value.forEach((element,index) => {
      this.chargeDetails.at(index).get('sacList').setValue(this.gstList);
      this.patchSacNameToSezDetails(element,index);
    });
    this.chargeDetailsDataSource.next(this.chargeDetails.controls);
  }

  private patchSacNameToSezDetails(element,index){
    let sacById=_.findWhere(this.gstList,{id:element.sacId});
    this.chargeDetails.at(index).get('sacName').setValue(sacById?.name);
 }

  getChargeTypeMechanism(){
    this.service.get(Api.CHARGE_TYPE_MECHANISM).subscribe(res => {
      if(res){
        this.chargeTypeMechanismList=res;
      }
    })
  }

  get chargeDetails(){ return <FormArray>this.chargeDetailForm.get('chargeDetails'); }
}
